import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "../errorPopup/errorPopup.module.css";
import mediaDevicesErrorPopupStyles from "./mediaDevicesErrorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function MediaDevicesErrorPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <h2
        className={`${popupStyles.popup__title} ${mediaDevicesErrorPopupStyles.popup__title}`}
      >
        {t('ALLOW_APP_ACCESS_CAMERA_MIC_1')}</h2>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={`${popupStyles.popup__img} ${mediaDevicesErrorPopupStyles.popup__img}`}
      />
      <p className={mediaDevicesErrorPopupStyles.popup__text}>
        {t('BROWSER_PERMISSION_ALERT')}</p>
      <p className={mediaDevicesErrorPopupStyles.popup__text}>
        {t('GOOGLE_CHROME_CAMERA_MIC')}</p>
      <p className={mediaDevicesErrorPopupStyles.popup__text}>
        {t('MOZILLA_FIREFOX_ACCESS')}</p>
      <p className={mediaDevicesErrorPopupStyles.popup__text}>
        {t('REFRESH_PAGE_AFTER_APPROVAL')}</p>
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >
        {t('APPROVAL')}</button>
    </article>
  );
}

export default MediaDevicesErrorPopup;
